import React from "react";
import { Link } from "react-router-dom";
import { inject, observer } from "mobx-react";
import GithubCorner from "react-github-corner";
import Web3Utils from "web3-utils";
import getWeb3 from "../getWeb3";
// import Logo from "/images/logo.png";

@inject("UiStore")
@observer
export class Header extends React.Component {
  state = {
    multisenderAddress: null,
    myAddress: null,
    chain: null,
  };

  formatAddress(address) {
    return address
      ? Web3Utils.toChecksumAddress(address).replace(
          /(.{6}).*(.{6})/,
          "$1...$2"
        )
      : "";
  }

  componentDidMount() {
    (async () => {
      const multisenderAddress =
        await this.props.UiStore.tokenStore.proxyMultiSenderAddress();
      let chain = await this.props.UiStore.web3Store.netIdName;
      if(chain == 'BCCMainnet') {
        chain = "BCC Mainnet";
      }
      const myAddress = await this.props.UiStore.web3Store.defaultAccount;
      this.setState({ multisenderAddress, chain, myAddress });
    })();
  }

  render() {
    const explorerUrl =
      this.props.UiStore.web3Store.explorerUrl || "https://etherscan.io";

    return (
      <header className="header">
        <div className="multisend-container">
          <a href="#" className="header-logo">
             <img
              src={"images/logo.png"}
              alt=""
              width="auto"
              //height="36"
            />
          </a>
          <form className="form form_header">
            {/* <Link className="button" to='/retry'>Retry Failed Transaction</Link> */}

            {this.state.myAddress ? (
              <>
                <label className="multisend-label">
                  Chain: {this.state.chain}
                </label>
                <label className="multisend-label">
                  My Address:{" "}
                  <a
                    target="_blank"
                    href={`${explorerUrl}/address/${this.state.myAddress}`}
                  >
                    {this.formatAddress(this.state.myAddress)}
                  </a>
                </label>
                <label className="multisend-label">
                  Contract Address:{" "}
                  <a
                    target="_blank"
                    href={`${explorerUrl}/address/${this.state.multisenderAddress}`}
                  >
                    {this.formatAddress(this.state.multisenderAddress)}
                  </a>
                </label>
              </>
            ) : null}
            {this.state.myAddress ? null : (
              <label className="multisend-label">
                <a
                  href="#"
                  onClick={() => {
                    window.ethereum &&
                      window.ethereum.request({
                        method: "eth_requestAccounts",
                      });
                  }}
                >
                  Connect Wallet
                </a>
              </label>
            )}
          </form>
        </div>
        {/*<div className="multisend-container">*/}
        {/*  Supports Mainnet, Ropsten, Rinkeby, Kovan, Goerli, BSC, Mumbai, Matic*/}
        {/*</div>*/}
      </header>
    );
  }
}
